import { AxiosResponse } from 'axios';
import AbstractHttpService from '../abstractHttpService';

import urls from '@const/urls';
import { IMandate, IMandateCreate } from '@app/store/modules/user/types';

class MandatesService extends AbstractHttpService {
  private readonly url = urls.mandates;

  /** Получение списка доверенностей */
  async getList(): Promise<AxiosResponse<IMandate[]>> {
    const url = this.url.list;

    return await this._http.get(url, {});
  }

  /** Получение списка доверенностей */
  async getListBox(boxOguid: string): Promise<AxiosResponse<IMandate[]>> {
    const url = this.url.listBox.replace('{{ boxOguid }}', boxOguid);

    return await this._http.get(url, {});
  }

  /** Получение доверенности по oguid */
  async get(oguid: string): Promise<AxiosResponse> {
    const url = this.url.single.replace('{{ oguid }}', oguid);

    return await this._http.get(url, {});
  }

  /** Создание доверенности */
  async create(mandate: IMandateCreate): Promise<AxiosResponse> {
    const url = this.url.create;

    return await this._http.post(url, mandate, {});
  }

  /** Обновление доверенности */
  async update(
    oguid: string,
    mandate: IMandateCreate
  ): Promise<IMandateCreate> {
    const url = this.url.single.replace('{{ oguid }}', oguid);

    return await this._http.put(url, mandate, {});
  }

  /** Удаление доверенности */
  async delete(oguid: string): Promise<AxiosResponse> {
    const url = this.url.single.replace('{{ oguid }}', oguid);

    return await this._http.delete(url, {});
  }
}

export default new MandatesService();
